import React, { useState, useEffect } from "react";
import DepositNotice from "../../notice/mobile/DepositNotice";
import { Link, useNavigate } from "react-router-dom";
import Toolbar from "../../navigation/mobile/Toolbar";
import UniversalBack from "../../common/mobile/UniversalBack";
import { Modal } from "react-bootstrap";
import Loader from "../../../common/Loader";
import { getDepositConfig, getDepositChannelLabel } from "./common/depositConfig";

function MDeposit({ items, promotions, userData , transactionData, hasEWallet, usdtRate, general}) {
	const [activeItem, setActiveItem] = useState(null);
	const [wapy, setWapy] = useState(false);
	const [activeAmount, setActiveAmount] = useState("");
	const [selectedPromotion, setSelectedPromotion] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [paymentSystems, setPaymentSystems] = useState([]);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState("");
	const token = localStorage.getItem("token");
	const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500", "100"];
	const [selectedOption, setSelectedOption] = useState(null);
	const [pgs, setPgs] = useState([]);
	const navigate = useNavigate();
	
	const [getotherContracts, setotherContracts] = useState([]);
	const [amountRange, setAmountRange] = useState([100, 25000]);
	const [currency, setCurrency] = useState("৳");
	const [presetAmounts, setPresetAmounts] = useState(["100",  "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
	const [depositChannel, setDepositChannel] = useState(false);
	const [showRate, setShowRate] = useState(false);
	const [rateLabel, setRateLabel] = useState("USDT");

	// ✅ Safety: never leave the deposit page stuck on the loading state
	// (replaces the old Splash behaviour which always finished after 2s)
	useEffect(() => {
		if (isLoading) {
			const t = setTimeout(() => setIsLoading(false), 4000);
			return () => clearTimeout(t);
		}
	}, [isLoading]);

	const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                   
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
		const fetchWay = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/wpay/check`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    // 👉 If HTTP status is 200 → WPay active
    if (response.status === 200) {
      setWapy(true);
    } else {
      setWapy(false);
      console.warn("WPay check failed:", response);
    }
  } catch (error) {
    console.error("Error fetching WPay check:", error);
    setWapy(false);
  }
};

	
	useEffect(() => { 
		fetchOther();
		fetchWay();
		let uniquePaymentMethods = [];
		const seenNames = new Set();

		if (items && items.length > 0) {
			items.forEach((item) => {
				if (item.name && !seenNames.has(item.name.toLowerCase())) {
					seenNames.add(item.name.toLowerCase());
					uniquePaymentMethods.push(item);
				}
			});
		}
		
		// 👉 If deposit_status is 0 from general settings, hide all payment methods
		if (Number(general?.deposit_status) === 0) {
			setPgs([]);
		} else {
			setPgs(uniquePaymentMethods);
		}
		
	}, []);

	// ✅ Auto-select the first payment method
	useEffect(() => {
		if (items.length > 0) {
			setPaymentMethod(items[0]);
		}
	}, [items]);

	// ✅ Auto-select the first promotion
	useEffect(() => {
		if (promotions.length > 0) {
		setSelectedPromotion(promotions[0]);
		}
	}, [promotions]);

	// ✅ Fetch deposit channels when payment method changes
	useEffect(() => {
		if (paymentMethod && hasEWallet===false) {
			const fetchPaymentMethodDetails = async () => {
				try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/showpayment-menthod?name=${paymentMethod.name}`, {
					headers: { Authorization: `Bearer ${token}`, 'Origin': window.location.origin },
				});
				const data = await response.json();

					if (data?.success && data.data.length > 0) {
					setPaymentSystems(data.data);
					setSelectedOption(data.data[0]?.id || null); // ✅ Auto-select the first deposit channel
				}
				} catch (error) {
					console.error("Error fetching payment method details:", error);
				} finally {
					setIsLoading(false);
				}
			};
			fetchPaymentMethodDetails();
		}
		if (hasEWallet === true) {
			// ✅ Removed setTimeout — filter directly using current paymentMethod
			let _filtered = [];
			for (let i = 0; i < items.length; i++) {
				if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
					_filtered.push(items[i]);
				}
			}
			setPaymentSystems(_filtered);
			setSelectedOption(_filtered[0]?.id || null);
			setIsLoading(false);
		}
	}, [paymentMethod, token, hasEWallet, items]); // ✅ Added hasEWallet and items to dependency array


	// ✅ Dynamic amount range, currency, presets & channel visibility based on
	// the selected channel's account_type/name/currency/network (see depositConfig)
	useEffect(() => { 
		const selectedMethod =
			paymentSystems.find((ps) => ps.id === selectedOption) ||
			items.find((item) => item.id === selectedOption);
		const config = getDepositConfig(selectedMethod);
		setAmountRange(config.range);
		setCurrency(config.symbol);
		setPresetAmounts(config.presets);
		setShowRate(!!config.showRate);
		setRateLabel(config.rateLabel || 'USDT');
		setDepositChannel(!config.hideChannel && paymentSystems.length > 0);
	}, [selectedOption, items, paymentSystems]);

	const handleItemClick = (name) => {
		const selectedMethod = items.find((item) => item.name === name);
		if (selectedMethod) {
			setPaymentMethod(selectedMethod);
			// ✅ Use selectedMethod directly instead of stale paymentMethod state
			let _filtered = [];
			for (let i = 0; i < items.length; i++) {
				if (items[i]?.name.toLowerCase() === selectedMethod?.name.toLowerCase()) {
					_filtered.push(items[i]);
				}
			}
			setPaymentSystems(_filtered);
			setSelectedOption(_filtered[0]?.id || null);
		}
	};

	const handleSelection = (id) => {
		setSelectedOption(id);
	};

	const handleAmountClick = (amount) => {
		setActiveAmount(amount);
	};

	const handlePromotionChange = (event) => {
		const selectedId = parseInt(event.target.value);
		const selectedPromo = promotions.find((promo) => promo.id === selectedId);
		setSelectedPromotion(selectedPromo || null);
	};

	const handleSubmit = async () => {
		window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'deposit_button_click',
    category: 'User Deposit',
    action: 'Click',
    label: 'Deposit Button'
  });

		// Get the current origin from data-origin attribute
		const currentOrigin = document.documentElement.getAttribute('data-origin') || '';
		
		// Skip verification for tkbet origin - deposit allowed without verification
		const skipVerificationOrigins = ['tkbet'];
		const shouldSkipVerification = skipVerificationOrigins.includes(currentOrigin.toLowerCase());

		// Phone verification removed: allow deposit without verification

		if (transactionData && transactionData.length > 0) {
			for (let trns of transactionData) {
				if (trns.action == "deposit" && trns.key === "0") {
					setModalMessage(`You already have a deposit request pending. Please wait for it to be processed before making another deposit.`);
					setShowModal(true);
					return;
				}
			}
		}
		
		if (!activeAmount) {
			setModalMessage("Please fill in your amount.");
			setShowModal(true);
			return;
		}

		if (!paymentMethod) {
			setModalMessage("Please select a valid payment method.");
			setShowModal(true);
			return;
		}

		const selectedPaymentSystem = paymentSystems.find(item => item.id === selectedOption);
		if (!selectedPaymentSystem) {
			setModalMessage("Please select a Deposit channel.");
			setShowModal(true);
			return;
		}

		try {
			if (hasEWallet) { 
				try {
					const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ewa/request`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${token}`,
							'Origin': window.location.origin,
						},
						body: JSON.stringify({
							amount: activeAmount,
							type: selectedPaymentSystem.account_type,
							provider: paymentMethod.name,
							promotion: selectedPromotion?.id || 0,
						}),
					});
					const data = await response.json();
					
					if (response.ok) {
						if (data?.url) {
							window.location.href = data.url;
							return;
						}
						navigate("/make-payment", {
							state: {
								amount: data?.amount ?? activeAmount,
								payment_icon: selectedPaymentSystem?.icon,
								payment_type: selectedPaymentSystem?.account_type,
								paymentMethodid: paymentMethod?.id,
								paymentMethodName: paymentMethod?.name,
								promotion: selectedPromotion?.id || null,
								transaction: data?.transaction,
								number: data?.number,
								timer: data?.timer ?? 10, 
								message: data?.message,
								network: selectedPaymentSystem?.network,
								currency: selectedPaymentSystem?.currency,
								provider: selectedPaymentSystem?.provider,
							},
						});
					} else {
						setModalMessage(data?.message || "An error occurred. Please try again.");
						setShowModal(true);
					}
					// } else {
					// }
				} catch (error) { 
					let err = error?.response?.data?.message || "An error occurred. Please try again.";
					setModalMessage(err || "An error occurred. Please try again.");
					console.error("Error fetching e-wallet request:", error);
					setModalMessage("An error occurred. Please try again.");
					setShowModal(true);
				}

			}
			else if (wapy) {
					const baseUrl = `${process.env.REACT_APP_API_URL}/api/payin`;

					
					const params = new URLSearchParams({
						amount: activeAmount,
						method: (paymentMethod?.name || '').toUpperCase(),
					});

					if (selectedPromotion?.id) {
						params.append("promotion", selectedPromotion.id);
					}

					const url = `${baseUrl}?${params.toString()}`;
					

					try {
						const response = await fetch(url, {
						method: "GET",
						headers: {
							"Authorization": `Bearer ${token}`,
							"Accept": "application/json",
						},
						});

						const data = await response.json();
						
						window.open(data[0].data.url, "_blank");
					} catch (error) {
						console.error("Error calling PayIn API:", error);
					}
					}

			else {
				navigate("/make-payment", {
					state: {
						amount: activeAmount,
						payment_icon: selectedPaymentSystem.icon,
						payment_type: selectedPaymentSystem.account_type,
						paymentMethodid: paymentMethod.id,
						paymentMethodName: paymentMethod.name,
						promotion: selectedPromotion?.id || null,
						network: selectedPaymentSystem.network,
						currency: selectedPaymentSystem.currency,
						provider: selectedPaymentSystem.provider,
					},
				});
			}
		} catch (error) {
			setModalMessage("An error occurred. Please try again.");
			setShowModal(true);
		} finally {
			setSubmitLoading(false);
		}
	};

	if (isLoading) {
		return (
			<Loader text="Loading..." />
		);
	}

	return (
		<div className="main-router-wrapper">
		<header id="header" className="login player">
			<div className="header-left-btn-group">
			<UniversalBack />
			</div>
			<div className="header-title">Funds</div>
			<div
			className="logo"
			tabIndex={0}
			style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/logo.png")' }}
			/>
		</header>

		<div className="wrap">
			<div className="content fixed-tab player-content">
			<div className="tab-btn-section tab-btn-wrap">
				<div className="tab-btn tab-btn-bar">
				<div className="line" style={{ width: "50%" }} />
				<div className="btn active">
					<Link className="text-white" to="/deposit">
					<div className="text">Deposit</div>
					</Link>
				</div>
				<div className="btn">
					<Link className="text-white" to="/withdrawal">
					<div className="text">Withdrawal</div>
					</Link>
				</div>
				</div>
			</div>

			<div className="tab-content disable">
				<div className="inner-wrap">
				<div className="inner-box deposit-wallet">
					<div className="player-deposit-wrap">
					<div className="player-deposit-step1">
						{/* Promotion Selector */}
						<div className="option-group select-bar">
						<label>
							<span
							className="item-icon"
							style={{
								backgroundImage:
								'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-selectpromotion.svg")',
							}}
							/>
							<div>Select Promotion</div>
						</label>
						<div className="option-wrap">
							<select
							value={selectedPromotion?.id || ""}
							onChange={handlePromotionChange}
							>
								<option value="" disabled hidden>
									{promotions.length ? 'Select Promotion' : 'Loading promotions...'}
								</option>
								{promotions.map((promotion) => (
									<option key={promotion.id} value={promotion.id}>
									{promotion.name}
									</option>
								))}
							</select>
						</div>
						</div>
						<DepositNotice />

						{/* Payment Method */}
						<div className="menu-box">
						<div className="title">
							<h2>Payment Method</h2>
						</div>
						{pgs.length === 0 ? (
							<div className="select-group checkbox-style" style={{ textAlign: 'center', padding: '30px 20px' }}>
								<p style={{ color: '#888', fontSize: '16px', margin: 0 }}>All channels are disabled now.</p>
							</div>
						) : (
						<div className="select-group checkbox-style">
							<ul className="col3">
							{pgs.map(
								(item) =>
								item.status === "active" && (
									<li
									key={item.id}
										
									className="ng-star-inserted"
									>
									<input
										type="radio"
										name="paymentMethod"
										id={`paymentMethod_${item.id}`}
										onChange={() => handleItemClick(item.name)}
										checked={paymentMethod?.name === item.name}
									/>
									<label htmlFor={`paymentMethod_${item.id}`}>
										<div className="bank ng-star-inserted">
										<img
											alt={item.name}
											src={`${process.env.REACT_APP_API_URL}/storage/${item.icon}`}
											loading="lazy"
										/>
										</div>
										<span>{item.name}</span>
										<div className="tag-rebate-money"><p ><span>+</span>{selectedPromotion?.deposit_bouns ? Math.round(selectedPromotion.deposit_bouns) : 0}
										<span>%</span></p></div>
									</label>
									</li>
								)
							)}
							</ul>
						</div>
						)}
						</div>

						{pgs.length > 0 && (
						<>
						{/* Deposit Channel - Only show if depositChannel is true */}				
						{depositChannel && (
							<div  className="deposit-normal ng-tns-c324864554-6 ng-star-inserted">
								<div  className="ng-tns-c324864554-6 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted" style={{}}>
								<div  className="menu-box ng-tns-c324864554-6 ng-star-inserted" style={{}}>
									<div  className="title ng-tns-c324864554-6">
									<h2  className="ng-tns-c324864554-6"><span  className="ng-tns-c324864554-6">Deposit Channel</span></h2>
									</div>
									<div  className="select-group checkbox-style checkbox-height-set ng-tns-c324864554-6">
									<ul className="col4 ng-tns-c324864554-6">
									{paymentSystems.map(ps => {
										const label = getDepositChannelLabel(ps);
										if (!label) return null;
										const cfg = getDepositConfig(ps);
										return (
										<li key={ps.id} className="ng-star-inserted">
											<input
												type="radio"
												name="depositSetting"
												id={`depositSetting_${ps.id}`}
												onChange={() => {
													handleSelection(ps.id);
													setActiveItem(ps.id);
												}}
												checked={selectedOption === ps.id}
											/>
											<label htmlFor={`depositSetting_${ps.id}`}>
												<span>{label}</span>
												{cfg.recommended && (
													<div className="tag-recommond ng-star-inserted">
													<span className="item-icon" style={{ maskImage: `url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-recommond.svg?v=1735038087741")` }} />
													</div>
												)}
												<span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/player/select-check.svg?v=1735038087741")' }} />
											</label>
										</li>
										);
									})}
								</ul>
									</div>
								</div>
								</div>
							</div>				
						)}
						{/* End Deposit Channel */}

						{/* Amount Selection */}
						<div className="menu-box active">
						<div className="title">
							<h2>
							Amount <i>{currency} {amountRange[0]} - {currency} {amountRange[1]}</i>
							</h2>
						</div>
						<div className="select-group style-add-amount">
							<ul className="col4">
							{presetAmounts.map((amount) => (
								<li
								key={amount}
								onClick={() => handleAmountClick(amount)}
								>
								<input
									type="radio"
									name="depositAmount"
									id={`depositAmount_${amount}`}
								/>
								<label htmlFor={`depositAmount_${amount}`}>
									<span>{amount}</span>
								</label>
								</li>
							))}
							</ul>
						</div>
						<div className="input-group money">
							<label htmlFor="amount">{currency}</label>
							<div className="inputbox">
								<input
									type="number"
									name="amount"
									className="input text-right"
									value={activeAmount}
									onChange={(e) => setActiveAmount(e.target.value)} 
									onClick={(e) => e.stopPropagation()} 
								/>
							</div>
							{ showRate && usdtRate && <div style={{ fontSize: "14px", marginTop: '10px', textAlign: 'center' }}>1 {rateLabel} = {usdtRate} BDT/TK</div>}
						</div> 
						</div>

						{/* Submit Button */}
						<div
						style={{ textAlign: "center" }}
						className="member-content "
						>
						<button
						onClick={handleSubmit}
							className="button">
						Next
						</button>
						</div>
						</>
						)}
						<Modal show={showModal} onHide={() => setShowModal(false)} centered>
							<Modal.Header closeButton>
								<Modal.Title>Error</Modal.Title>
							</Modal.Header>
							<Modal.Body dangerouslySetInnerHTML={{ __html: modalMessage }}>
							</Modal.Body>
						</Modal>
					</div>
					</div>
				</div>
				</div>
			</div>
			</div>
		</div>
		<Toolbar />
		</div>
	);
}

export default MDeposit;
